import type { Project } from "@mnk/shared/models/project";
import { useEffect, useRef } from "react";
import { A4_HEIGHT, A4_WIDTH } from "../const";

const toReiwa = (yearStr: string): string => {
  const year = Number(yearStr);
  if (!year) return "〇〇";
  return String(year);
};

// ── テキスト縦位置（Y座標）個別調整 ──
const Y_FISCAL_YEAR    = 370;  // 令和〇〇年度
const Y_WORK_TITLE     = 540;  // 業務タイトル
const Y_DRAWING_TYPE   = 880;  // 設計図 / 変更図
const Y_WORK_DETAIL    = 970; // 工事名（工事詳細）
const Y_WORK_YEAR_MONTH = 1210; // 令和〇〇年〇〇月
const Y_COMPANY        = 1510; // 株式会社ネクスコ・メンテナンス関東
const Y_OFFICE_NAME    = 1650; // 事業所名

interface Props {
  project: Project;
  officeName: string;
  onCapture: (dataURL: string) => void;
}

export const CoverPage = ({ project, officeName, onCapture }: Props) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const W = A4_WIDTH;
    const H = A4_HEIGHT;

    // 背景
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);

    // 外枠
    ctx.strokeStyle = "#000000";
    ctx.lineWidth = 2;
    const marginX = 175;
    const marginY = 120;
    ctx.strokeRect(marginX, marginY, W - marginX * 2, H - marginY * 2);

    // テキスト共通設定
    ctx.fillStyle = "#000000";
    ctx.textAlign = "center";
    const cx = W / 2;
    const TEXT_SIZE = 60;
    ctx.font = `${TEXT_SIZE}px sans-serif`;

    const fiscalYearText = project.fiscalYear ? `令和${toReiwa(project.fiscalYear)}年度` : "令和〇〇年度";
    ctx.fillText(fiscalYearText, cx, Y_FISCAL_YEAR);

    ctx.fillText(project.workTitle ?? "業務タイトル", cx, Y_WORK_TITLE);

    const drawingTypeText = project.drawingType ?? "〇　　〇　　図";
    const displayDrawingType = project.drawingType ? project.drawingType.split("").join("　　") : drawingTypeText;
    ctx.fillText(displayDrawingType, cx, Y_DRAWING_TYPE);

    ctx.fillText(project.workDetail ?? "工事名詳細", cx, Y_WORK_DETAIL);

    ctx.fillText(project.workYearMonth ?? "令和〇〇年〇〇月", cx, Y_WORK_YEAR_MONTH);

    ctx.fillText("株式会社ネクスコ・メンテナンス関東", cx, Y_COMPANY);

    ctx.fillText(officeName, cx, Y_OFFICE_NAME);

    onCapture(canvas.toDataURL("image/png"));
  }, [project, officeName, onCapture]);

  return <canvas ref={canvasRef} width={A4_WIDTH} height={A4_HEIGHT} style={{ display: "none" }} />;
};
